import { useState } from "react"
import { HighPriorityNovaModalContainer } from "@nova/component-nova-modal-container"
import { ToggleSwitch } from "@nova/component-toggle-switch"
import { ButtonSecondary, ButtonPrimary } from "@nova/component-btn"
import { useAppDispatch } from "integrations/redux/hooks"
import { hideGlobalModal } from "runlevel/actions"
import { useFeatureFlagToggles, featureFlagTogglesFlag } from "./useFeatureFlag"

export const FeatureFlagToggleModal = () => {
    const dispatch = useAppDispatch()
    const toggles = useFeatureFlagToggles()
    const [pendingSelfDisable, setPendingSelfDisable] = useState(false)

    return (
        <HighPriorityNovaModalContainer
            title="Feature Flags"
            closeModal={() => dispatch(hideGlobalModal())}
            className="max-w-[480px] w-full"
            bottomBar={
                <div className="flex w-full justify-end">
                    <ButtonSecondary onClick={() => dispatch(hideGlobalModal())} title="Done" />
                </div>
            }
        >
            <div className="flex flex-col gap-1 overflow-y-auto">
                {toggles.map(({ flag, enabled, setEnabled }) => {
                    const isSelfFlag = flag === featureFlagTogglesFlag
                    const isPending = isSelfFlag && pendingSelfDisable

                    return (
                        <div
                            key={flag}
                            className="flex items-center justify-between gap-4 py-2 px-1 rounded hover:bg-gray-800"
                        >
                            <span className="text-gray-100 truncate">{flag}</span>
                            <div className="flex items-center gap-2 shrink-0">
                                {isPending && (
                                    <ButtonPrimary
                                        title="Confirm"
                                        height="h-6"
                                        onClick={() => {
                                            setEnabled(false)
                                            dispatch(hideGlobalModal())
                                        }}
                                    />
                                )}
                                <ToggleSwitch
                                    isToggled={isPending ? false : enabled}
                                    setIsToggled={(next) => {
                                        if (!isSelfFlag) return setEnabled(next)
                                        setPendingSelfDisable(!next)
                                    }}
                                />
                            </div>
                        </div>
                    )
                })}
            </div>
        </HighPriorityNovaModalContainer>
    )
}
